<template>
  <!-- 船员信息 -->
  <div class="crew-info">
    <el-tooltip placement="top"
                :visible="visible">
      <template #content>
        <div class="info-table">
          <el-table
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{textAlign: 'center'}"
            :row-style="setRowStyle"
            :max-height="tableHeight"
          >
            <el-table-column v-for="(item,index) in columnData"
                             :key="index"
                             :class-name="item.classname"
                             :min-width="item.width"
                             align="center"
                             :label="item.label">
              <template #default="scope">
                <span>{{scope.row[item.value]?scope.row[item.value]:'--'}}</span>
              </template>
            </el-table-column>
            <!--     :width="drugColumnWidth.name"
                             align="center"
                             class-name="table-drugs-groupno"
                             show-overflow-tooltip -->

          </el-table>
        </div>
      </template>
      <div id="crewInfo">
      </div>
    </el-tooltip>

  </div>
</template>
<script>
import * as echarts from "echarts";
import moment from "moment";
// import { option } from "../../assets/chartData/goodsDistribution";
// import { toRaw } from 'vue'

export default {
  props: {
    clientWidth: {
      type: Number,
      default: () => {
        return null;
      },
    },
    crewInfo: {
      type: Object,
      default: () => {
        return null;
      },
    },
    changeWidth: {
      type: Boolean,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      visible: false, //是否显示tooltip
      echartData: {}, //所有数据
      option: {},
      xData: [], // x轴label数据
      value: [], //图表数据
      colorStops: [], //图表各个柱子颜色
      myChart: null,
      tableData: [], //tooltip 表格数据
      columnData: [
        {
          value: "name",
          label: "姓名",
          width: "25",
        },
        {
          value: "rank",
          label: "职位",
          width: "10",
        },
        {
          value: "nation",
          label: "国籍",
          width: "10",
        },
        {
          value: "change_sign_on",
          label: "上船时间",
          width: "12",
        },
        {
          value: "sign_on_place",
          label: "上船地点",
          width: "15",
        },
        {
          value: "end_of_contract",
          label: "合同到期时间",
          width: "12",
        },
        // {
        //   value: "sign_off_place",
        //   label: "下船地点",
        //   width: "15",
        // },
      ], //tooltip 内表格循环数据
      tableHeight: `${document.body.clientHeight / 2}px`
    };
  },
  watch: {
    crewInfo: function (newV) {
      // console.log(newV)
      this.initData();
    },
    changeWidth(newV) {
      if (newV) {
        this.initData();
      }
    },
  },
  mounted() {
    this.initData();
    document.addEventListener("click", (e) => {
      // console.log(e, e.target.className);
      if (
        this.visible == true &&
        (e.target.className.indexOf("el-table__cell") == -1 ||
          e.target.className.indexOf("cell") == -1 ||
          e.target.className.indexOf("el-table__row") == -1)
      ) {
        // console.log("ccc");
        this.visible = false;
      }
    });
  },
  methods: {
    initChart(data, chart) {
      let that = this;
      data && chart.setOption(data);
      //点击事件
      data &&
        chart.on("click", function (params) {
          that.checkTableData(params);
          // var name = parseInt(params.name);
        });
    },
    // 校验表格数据
    checkTableData(params) {
      let that = this;
      that.tableData = params.data.list;
      moment.defaultFormat = "YYYY-MM-DD HH:mm:ss";
      that.tableData.forEach((item) => {
        let UtfTime = moment(item.sign_on_date, moment.defaultFormat).toDate();
        if (item.sign_on_date) {
          item.change_sign_on = moment(UtfTime).format("YYYY-MM-DD");
        } else {
          item.change_sign_on = "--";
        }
        UtfTime = moment(item.end_of_contract, moment.defaultFormat).toDate();
        if (item.end_of_contract) {
          item.end_of_contract = moment(UtfTime).format("YYYY-MM-DD");
        } else {
          item.end_of_contract = "--";
        }
        item.color = "white";
        if (params.name == "全部船员") {
          if (this.crewInfo.overdueLi.length > 0) {
            this.crewInfo.overdueLi.forEach((overItem) => {
              if (overItem.name == item.name) {
                item.color = "red";
              }
            });
          }
        }
      });
      // console.log(that.tableData);
      that.$emit("clearManageInterval");
      setTimeout(() => {
        that.visible = true;
      }, 50);
    },
    // 表格行样式
    setRowStyle({ row, rowIndex }) {
      if (row.color == "red") {
        return {
          color: "#df6043 !important",
        };
      }
    },
    initData() {
      if (this.myChart) {
        this.myChart.dispose();
      }

      var chartDom = document.getElementById("crewInfo");
      this.myChart = echarts.init(chartDom);

      this.handlerData();
      if (this.clientWidth <= 1921) {
        this.initDataUnder1920();
      } else if (this.clientWidth > 1921 && this.clientWidth <= 2560) {
        this.initDataUnder2560();
      } else {
        this.initDataUp4368();
      }
      this.initChart(this.option, this.myChart);
    },
    handlerData() {
      this.xData = [];
      this.value = [];
      this.colorStops = [];
      this.echartData = [
        {
          label: "满11个月",
          data: this.crewInfo.elevenMonthsOnBoardCount || 0,
          list: this.crewInfo.elevenMonthsOnBoard || [],
          color: { top: "#FF0000", bottom: "#C3482E" },
        },
        {
          label: "合同超期",
          data: this.crewInfo.overdueCount || 0,
          list: this.crewInfo.overdueLi || [],
          color: { top: "#e8684a", bottom: "#C3482E" },
        },
        {
          label: "30天内到期",
          data: this.crewInfo.thirtyOffCount || 0,
          list: this.crewInfo.thirtyOff || [],
          color: { top: "#f6bd16", bottom: "#C59300" },
        },
        {
          label: "30天内上船",
          data: this.crewInfo.thirtyOnCount || 0,
          list: this.crewInfo.thirtyOn || [],
          color: { top: "#5b8ff9", bottom: "#7C7DE1" },
        },
        {
          label: "全部船员",
          data: this.crewInfo.allCrewCount || 0,
          list: this.crewInfo.allCrewLi || [],
          color: { top: "#6dc8ec", bottom: "#26a8f0" },
        },
      ];
      this.echartData.forEach((item) => {
        const label = item.label || "";
        this.xData.push(label);
        const value = {
          list: item.list,
          value: item.data || 0,
        };
        this.value.push(value);
        this.colorStops.push(item.color);
      });
      // console.log(this.value, "value");
    },
    initDataUnder1920() {
      this.option = {
        tooltip: {
          show: false,
          // trigger: 'axis',
          textStyle: {
            color: "rgba(255, 255, 255, 1)",
            align: "left",
            fontSize: 12,
          },
          backgroundColor: "rgba(72, 156, 255, 0.6)",
          borderColor: "rgba(0, 0, 0, 0)",
        },
        grid: {
          left: "1%",
          top: "0%",
          right: "20",
          bottom: "5%",
          containLabel: true,
        },

        xAxis: {
          type: "value",
          show: false,
          position: "top",
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: [
          {
            type: "category",
            axisTick: {
              show: false,
              alignWithLabel: false,
              // length: 5,
            },
            splitLine: {
              //网格线
              show: false,
            },
            // inverse: 'true', //排序
            axisLine: {
              show: false,
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              show: true, //这里的show用于设置是否显示y轴下的字体 默认为true
              fontSize: "12",
            },
            data: this.xData,
          },
        ],
        series: [
          {
            name: "船员人数统计",
            data: this.value,
            type: "bar",
            barWidth: 30,
            label: {
              show: true,
              position: "right",
              formatter: "{c}",
              fontSize: "12",

              color: "white", //color of value
            },
            itemStyle: {
              show: true,
              color: (params) => {
                let num = this.colorStops.length;
                // console.log(this.colorStops);
                return {
                  type: "linear",
                  colorStops: [
                    {
                      offset: 0,
                      color: this.colorStops[params.dataIndex % num].bottom,
                    },
                    {
                      offset: 1,
                      color: this.colorStops[params.dataIndex % num].top,
                    },
                    {
                      offset: 0,
                      color: this.colorStops[params.dataIndex % num].bottom,
                    },
                    {
                      offset: 1,
                      color: this.colorStops[params.dataIndex % num].top,
                    },
                    {
                      offset: 0,
                      color: this.colorStops[params.dataIndex % num].bottom,
                    },
                    {
                      offset: 1,
                      color: this.colorStops[params.dataIndex % num].top,
                    },
                  ],
                  //globalCoord: false
                };
              },
              // barBorderRadius: 70,
              borderWidth: 0,
              borderColor: "#333",
            },
            barGap: "0%",
            barCategoryGap: "70%",
          },
        ],
      };
      // this.option = toRaw(option)
    },
    initDataUnder2560() {
      this.option = {
        tooltip: {
          show: false,
          // trigger: 'axis',
          textStyle: {
            color: "rgba(255, 255, 255, 1)",
            align: "left",
            fontSize: 24,
          },
          backgroundColor: "rgba(72, 156, 255, 0.6)",
          borderColor: "rgba(0, 0, 0, 0)",
        },
        grid: {
          left: "1%",
          top: "0%",
          right: "30",
          bottom: "5%",
          containLabel: true,
        },

        xAxis: {
          type: "value",
          show: false,
          position: "top",
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: [
          {
            type: "category",
            axisTick: {
              show: false,
              alignWithLabel: false,
              // length: 5,
            },
            splitLine: {
              //网格线
              show: false,
            },
            // inverse: 'true', //排序
            axisLine: {
              show: false,
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              show: true, //这里的show用于设置是否显示y轴下的字体 默认为true
              fontSize: "24",
            },
            data: this.xData,
          },
        ],
        series: [
          {
            name: "船员人数统计",
            data: this.value,
            type: "bar",
            barWidth: 50,
            label: {
              show: true,
              position: "right",
              formatter: "{c}",
              fontSize: "24",

              color: "white", //color of value
            },
            itemStyle: {
              show: true,
              color: (params) => {
                let num = this.colorStops.length;
                return {
                  type: "linear",
                  colorStops: [
                    {
                      offset: 0,
                      color: this.colorStops[params.dataIndex % num].bottom,
                    },
                    {
                      offset: 1,
                      color: this.colorStops[params.dataIndex % num].top,
                    },
                    {
                      offset: 0,
                      color: this.colorStops[params.dataIndex % num].bottom,
                    },
                    {
                      offset: 1,
                      color: this.colorStops[params.dataIndex % num].top,
                    },
                    {
                      offset: 0,
                      color: this.colorStops[params.dataIndex % num].bottom,
                    },
                    {
                      offset: 1,
                      color: this.colorStops[params.dataIndex % num].top,
                    },
                  ],
                  //globalCoord: false
                };
              },
              // barBorderRadius: 70,
              borderWidth: 0,
              borderColor: "#333",
            },
            barGap: "0%",
            barCategoryGap: "70%",
          },
        ],
      };
      // this.option = toRaw(option)
    },
    initDataUp4368() {
      this.option = {
        tooltip: {
          show: false,
          // trigger: 'axis',
          textStyle: {
            color: "rgba(255, 255, 255, 1)",
            align: "left",
            fontSize: 30,
          },
          backgroundColor: "rgba(72, 156, 255, 0.6)",
          borderColor: "rgba(0, 0, 0, 0)",
        },
        grid: {
          left: "1%",
          top: "0%",
          right: "50",
          bottom: "10%",
          containLabel: true,
        },

        xAxis: {
          type: "value",
          show: false,
          position: "top",
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: [
          {
            type: "category",
            axisTick: {
              show: false,
              alignWithLabel: false,
              // length: 5,
            },
            splitLine: {
              //网格线
              show: false,
            },
            inverse: "true", //排序
            axisLine: {
              show: false,
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              show: true, //这里的show用于设置是否显示y轴下的字体 默认为true
              fontSize: "30",
            },
            data: this.xData,
          },
        ],
        series: [
          {
            name: "船员人数统计",
            data: this.value,
            type: "bar",
            barWidth: 70,
            label: {
              show: true,
              position: "right",
              formatter: "{c}",
              fontSize: "30",

              color: "white", //color of value
            },
            itemStyle: {
              show: true,
              color: (params) => {
                let num = this.colorStops.length;
                return {
                  type: "linear",
                  colorStops: [
                    {
                      offset: 0,
                      color: this.colorStops[params.dataIndex % num].bottom,
                    },
                    {
                      offset: 1,
                      color: this.colorStops[params.dataIndex % num].top,
                    },
                    {
                      offset: 0,
                      color: this.colorStops[params.dataIndex % num].bottom,
                    },
                    {
                      offset: 1,
                      color: this.colorStops[params.dataIndex % num].top,
                    },
                    {
                      offset: 0,
                      color: this.colorStops[params.dataIndex % num].bottom,
                    },
                    {
                      offset: 1,
                      color: this.colorStops[params.dataIndex % num].top,
                    },
                  ],
                  //globalCoord: false
                };
              },
              // barBorderRadius: 70,
              borderWidth: 0,
              borderColor: "#333",
            },
            barGap: "0%",
            barCategoryGap: "70%",
          },
        ],
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.crew-info {
  width: 100%;
  height: 100%;
}
#crewInfo {
  width: 100%;
  height: 100%;
}
.info-table {
  // max-width: 50vw !important;
  width: 50vw;
  height: 50vh !important;
  word-wrap: break-word;
  overflow: auto;
  // background-color: #011832d9 !important;
  border: 0px !important;
  span {
    max-width: 50vw !important;
    word-wrap: break-word;
  }
}
::v-deep .el-popper {
  overflow: hidden !important;
}
:deep(.el-table) {
  background-color: transparent !important;
  --el-table-border-color: #0118327a !important;
  --el-table-row-hover-bg-color: #0118327a !important;
  cursor: pointer;
}

:deep(.el-table tr) {
  background: transparent !important;
  color: white;
}
:deep(.el-table th.el-table__cell) {
  background: transparent !important;
  color: #53c6ef;
}
:deep(.el-table tr:hover) {
  background: transparent !important;
  color: white;
}
:deep(.el-table .cell) {
  padding: 0 1% !important;
  word-break: break-word !important;
}
</style>